export default __webpack_public_path__ + "static/media/LEVEL4.f56abaee.png";